import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Row } from 'antd';
import { FormInput, MasterDetailForm, FormSelect, FormDatePicker, FormTextArea } from '@digital/ui';
import { getAllModalidadesContratoOptions, updateInformacoesComplementares } from '@app/api/sas/ordemCompra';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';
import moment from 'moment';
import { dadosGeraisState, reloadState, statusCodigoState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Visibility } from '@app/components';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import CurrencyInput from '@app/components/CurrencyInput';
import { ETipoContrato } from '@app/enums/ETipoContrato';

const { Panel } = Collapse;

interface props {
    //setHasIncluded: React.Dispatch<React.SetStateAction<boolean>>;
    hasIncluded: boolean;
    ordemCompraId: string;
    dataFinal: Date | undefined;
    dataInicial: Date | undefined;
    setDataInicial: React.Dispatch<React.SetStateAction<Date | undefined>>;
    setDataFinal: React.Dispatch<React.SetStateAction<Date | undefined>>;
    valorTotal: number | undefined;
    data: any;
}

const WidgetIntegracaoAditivo = ({
    hasIncluded,
    ordemCompraId,
    dataFinal,
    dataInicial,
    setDataInicial,
    setDataFinal,
    valorTotal,
    data
}: props) => {
    const [dadosGerais, setDadosGerais] = useRecoilState(dadosGeraisState);

    const [reload, setReload] = useRecoilState(reloadState);
    const statusCodigo = useRecoilValue(statusCodigoState);
    const [statusDisable, setStatusDisable] = useState(true);

    const ehPCS = (dadosGerais.modalidadeContratoTotvs || '').toLocaleLowerCase() === ETipoContrato.PCS;

    const onReload = () => {
        setReload(!reload);
    };

    //foi dito, dia 04/10, ocultar o botão de salvar, todos os campos deesabilitados para edição E fixos com seus valores default
    const handleSubmitInformacoesComplementares = (values: any) => {
        const valuesToSend = { ...values };
        valuesToSend.dataFinal = moment(dataFinal).toISOString();
        valuesToSend.dataInicio = moment(dataInicial).toISOString();
        valuesToSend.id = ordemCompraId;

        updateInformacoesComplementares(valuesToSend).then((data: any) => {
            if (data.valid) onReload();
        });
    };

    useEffect(() => {
        if (statusCodigo == EStatusOrdemCompra.Cancelada || statusCodigo == EStatusOrdemCompra.Concluido) {
            setStatusDisable(false);
        }
    }, [statusCodigo]);

    return (
        <Visibility visible={isObjNotEmpty(dadosGerais) && isObjNotEmpty(statusCodigo)}>
            <Collapse
                bordered={false}
                defaultActiveKey={'IntegracaoDeAditivoTotvs'}
                expandIcon={() => <Icon type="arrows-right_4" />}
            >
                <Panel
                    key="IntegracaoDeAditivoTotvs"
                    header={ehPCS ? 'Integração de Aditivo PCS - Totvs' : 'Integração de Aditivo - Totvs'}
                >
                    <>
                        <MasterDetailForm
                            initialValues={data}
                        //onSubmit={handleSubmitInformacoesComplementares}
                        // actions={[
                        //     <Visibility visible={!hasIncluded}>
                        //         <FormSubmitButton
                        //             style={{ margin: 10 }}
                        //             type="success"
                        //             title="Salvar"
                        //             noIcon
                        //         />
                        //     </Visibility>
                        // ]}
                        >
                            <Row>
                                <FormInput
                                    name='contrato'
                                    label={ehPCS ? 'N° PCS' : 'N° Contrato'}
                                    span={3}
                                    disabled
                                />

                                <FormInput
                                    name='statusAprovacaoAditivo'
                                    label={ehPCS ? 'Status da Aprovação do Aditivo PCS' : 'Status da Aprovação do Aditivo'}
                                    span={3}
                                    disabled
                                />

                                <FormInput
                                    name='statusAprovacaoAditivoTotvs'
                                    label={ehPCS ? 'Status Aditivo PCS TOTVS' : 'Status Aditivo TOTVS'}
                                    span={3}
                                    disabled
                                />
                            </Row>
                            <Row>
                                <FormSelect
                                    name="modalidadeContrato"
                                    label="Modalidade de Contrato"
                                    span={3}
                                    getOptions={getAllModalidadesContratoOptions}
                                    required
                                    disabled
                                />
                                <FormSelect
                                    name="tipoControleContrato"
                                    label="Tipo de Controle do Contrato"
                                    span={3}
                                    options={[
                                        { value: 1, text: "01 - Total Nota" },
                                        { value: 2, text: "02 - Item" },
                                    ]}
                                    required
                                    disabled
                                />
                                <FormSelect
                                    name="unidadeMedicao"
                                    label="Unidade de Medição"
                                    span={2}
                                    options={[
                                        { value: 1, text: "01 - Valor" },
                                        { value: 2, text: "02 - Percentual" },
                                    ]}
                                    required
                                    disabled
                                />
                                <FormSelect
                                    name="caracteristicaItem"
                                    label="Característica Item"
                                    span={2}
                                    options={[
                                        { value: 1, text: "01 - Aditivo" },
                                        { value: 2, text: "02 - Redutor" },
                                    ]}
                                    required
                                    disabled
                                />
                                <FormSelect
                                    name="controlePrecoQtde"
                                    label="Controle Preço / Qtde"
                                    span={2}
                                    options={[
                                        { value: 1, text: "01 - Qtde e Preço" },
                                        { value: 2, text: "02 - Qtde Aberta e Preço" },
                                        { value: 3, text: "03 - Limite Custo" },
                                    ]}
                                    required
                                    disabled
                                />
                            </Row>
                            <Row>
                                <FormTextArea
                                    label={ehPCS ? 'Narrativa do PCS' : 'Narrativa do Contrato'}
                                    name="narrativaContrato"
                                    span={12}
                                    rows={3}
                                    disabled
                                />
                            </Row>
                            <Row>
                                <FormDatePicker
                                    label={ehPCS ? 'Data Início do PCS' : 'Data Início do Contrato'}
                                    name="dataInicioContrato"
                                    format="DD/MM/YYYY"
                                    span={3}
                                    disabled
                                />
                                <FormDatePicker
                                    label={ehPCS ? 'Data Final do PCS' : 'Data Final do Contrato'}
                                    name="dataFinalContrato"
                                    format="DD/MM/YYYY"
                                    span={3}
                                    disabled
                                />
                                <CurrencyInput
                                    label={ehPCS ? 'Valor Atual do PCS' : 'Valor Atual do Contrato'}
                                    name='valorTotal'
                                    value={valorTotal}
                                    span={3}
                                    disabled
                                />
                            </Row>
                        </MasterDetailForm>
                    </>
                </Panel>
            </Collapse>
        </Visibility>
    );
};

export default WidgetIntegracaoAditivo;